import { defineStore } from '#q-app';
import { createPinia } from 'pinia';
import type { Router } from 'vue-router';
import { createORM } from 'pinia-orm';
// import {
//   useStrapiUserUpdate,
//   StrapiUserUpdateItem,
// } from './strapiUpdate/useStrapiUserUpdate';
// import { Child } from 'app/pinia-orm-models/Child';
// import { Profile } from 'app/pinia-orm-models/Profile';

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
    readonly router: Router;
  }
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default defineStore((/* { ssrContext } */) => {
  const pinia = createPinia().use(createORM());

  // Action tracing is a development aid; in production it logged on every
  // single action and retained references to full store instances.
  if (import.meta.env.QUASAR_DEV) {
    pinia.use(({ store }) => {
      store.$onAction(({ name, args }) => {
        console.log({ store, action: name, args });
      });
    });
  }

  // You can add Pinia plugins here
  // pinia.use(SomePiniaPlugin)

  return pinia;
});
